export default (path) => (new URL(`${window.location.origin}/app/api${path}`).href); 